import angular from 'angular';

angular
  .module('lad-mock', [])

  .config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider.state('lad-mock', {
        url: '/lad-mock',
        controller: 'LadMockCtrl',
        templateUrl: require('./lad-mock.html'),
        controllerAs: 'vm',
        data: {
          authorizedRole: 'USER_BO'
        }
      });
    }
  ]);
